<!-- =========================================================================================
  File Name: Clients.vue
  Description: Apps Clients
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="apps-clients" class="data-list-container">

    <vs-prompt
        title="Новое уведомление"
        cancel-text= "Отменить"
        accept-text= "Создать"
        button-cancel = "border"
        @cancel="clearFields"
        @accept="createNotify"
        @close="clearFields"
        :is-valid="validateForm"
        :active.sync="activePrompt">
        <div>
            <form>

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-input v-validate="'required'" name="title" class="w-full mb-4 mt-2" placeholder="Заголовок" v-model="notifyLocal.header" :color="validateForm ? 'success' : 'danger'" />
                        <vs-textarea rows="5" label="Содержание" v-model="notifyLocal.text" />
                        <vs-select v-model="notifyLocal.type" label="Тип уведомления" class="w-50">
                            <vs-select-item :key="item.value" :value="item.value" :text="item.label" v-for="item in notifyTypeList" />
                        </vs-select>
                    </div>
                </div>

            </form>
        </div>
    </vs-prompt>



    <!-- <vx-card ref="filterCard" title="Фильтры" class="notify-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Тип</label>
          <v-select :options="typeOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="typeFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Статус</label>
          <v-select :options="stateOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="stateFilter" class="mb-4 md:mb-0" />
        </div>
      </div>
    </vx-card> -->

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div>
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ clientsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : clientsData.length }} of {{ clientsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(250)">
                <span>250</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>


        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="pl-4 pr-4 cursor-pointer flex-shrink">

          <div class="sm:mr-4 p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
            <span class="mr-2 leading-none">Действия</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-6 w-6" />
          </div>

          <vs-dropdown-menu>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg text-success" @click="confirmCreateNotify">
                <feather-icon icon="CheckIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Создать уведомление</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg" @click="gridApi.exportDataAsCsv()">
                <feather-icon icon="SaveIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Экспорт CSV</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg text-danger" @click="clientDelete">
                <feather-icon icon="TrashIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Удалить</span>
              </span>
            </vs-dropdown-item>

          </vs-dropdown-menu>
        </vs-dropdown>


        <div class="flex-shrink">
          <vs-button type="border" color="success" icon-pack="feather" icon="icon-plus" class="mr-4" @click="clientCreate">Создать Клиента</vs-button>
        </div>
        
        <div class="flex-grow">
          <vs-button type="border" color="primary" icon-pack="feather" icon="icon-refresh-cw" class="mr-4" @click="clientsUpdate">Обновить</vs-button>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Поиск..." />

      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="clientsData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>

  </div>

</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

import moduleClient from '@/store/client/moduleClient.js'
import moduleNotify from '@/store/notify/moduleNotify.js'

export default {
  components: {
    AgGridVue,
    vSelect,
  },
  data() {
    return {

      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        suppressMovable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'clid',
          width: 180,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: 'Аккаунт',
          field: 'aid',
          filter: true,
          width: 140,
        },
        {
          headerName: 'Login',
          field: 'login',
          filter: true,
          width: 180,
        },
        {
          headerName: 'E-mail',
          field: 'email',
          filter: true,
          width: 240,
        },
        {
          headerName: 'RegTime',
          field: 'reg_time',
          filter: true,
          width: 200,
        },
        {
          headerName: 'Статус',
          field: 'state',
          width: 140,
        },
        {
          headerName: 'Роль',
          field: 'role',
          width: 140,
        },
      ],

      activePrompt: false,

      notifyLocal: {
        header: "",
        text: "",
        type: 0,
      },
      notifyTypeList: moduleNotify.notifyTypeList,

    }
  },
  computed: {
    clientsData() {
      return this.$store.getters["client/getClients"]
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    validateForm() {
        return !this.errors.any() && this.notifyLocal.header != '' && this.notifyLocal.text != ''
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  },
  created() {
    if (!moduleClient.isRegistered) {
      this.$store.registerModule('client', moduleClient)
      moduleClient.isRegistered = true
    }
    this.clientsUpdate()

    if (!moduleNotify.isRegistered) {
      this.$store.registerModule('notify', moduleNotify)
      moduleNotify.isRegistered = true
    }
  },
  destroyed() {
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    clientsUpdate() {
      this.$store.dispatch("client/fetchClients")
      .then(() => {
        this.updateSearchQuery(this.searchQuery)
        // сбрасываем фильтры, иначе нужно найти способ обновить таблицу согласно выбранным фильтрам
        // this.typeFilter = this.stateFilter = { label: 'Все', value: 'all' }
      })
    },
    clientCreate() {

    },
    clientDelete() {

    },
    

    confirmCreateNotify() {
      if (this.gridApi.getSelectedRows().length) {
        this.activePrompt = true
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Создание уведомления`,
          text: `Выберите из списка клиентов, для которых хотите создать уведомление.`,
          acceptText: "Ок",
        })
      }
    },
    createNotify() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.dispatch('notify/createNotify', Object.assign({clients: this.gridApi.getSelectedRows()}, this.notifyLocal))
          this.clearFields()
        }
      })
    },
    clearFields() {
      Object.assign(this.notifyLocal, {
        header: "",
        text: "",
        type: 0,
      })
    },
    
  },
}
</script>

<style lang="scss">
#apps-clients {
  .strong {
    font-weight: 600;
  }
  .sticon {
    margin-right: .4rem;
    width: 1.4rem;
    height: 1.4rem;
  }
  // .client-status {
  //   display: flex;
  // }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .client-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 .8rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            // padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
